import { Button as MuiButton, ButtonProps as MuiButtonProps, styled } from "@mui/material";
import React, { forwardRef } from "react";

import { colors } from "@/Utils";

import { brandColors } from "../../utils/brand-colors";

const StyledButton = styled(MuiButton)(({ theme }) => {
  return {
    backgroundColor: theme.palette.mode === "light" ? brandColors.pirateBlack : colors.white,
    color: theme.palette.mode === "light" ? colors.white : colors.black,

    borderRadius: "6.25rem",
    textTransform: "none",
    padding: "0.25rem 1.25rem",
    width: "fit-content",

    "&:hover": {
      borderColor: "#79747E",
    },
  };
});

interface ButtonProps extends MuiButtonProps {
  children: React.ReactNode;
}

export const OutlinedButton2 = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, ...props }, ref) => {
    return (
      <StyledButton ref={ref} {...props}>
        {children}
      </StyledButton>
    );
  }
);

export default OutlinedButton2;
